import { InjectionToken  } from '@angular/core';

export const BaseEndpoint = new InjectionToken('BaseEndpoint');



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/app.constants.ts